// Options Actions
export const FETCH_AUDIT_LOGS_REQUEST = "FETCH_AUDIT_LOGS_REQUEST";
export const FETCH_AUDIT_LOGS_SUCCESS = "FETCH_AUDIT_LOGS_SUCCESS";
export const FETCH_AUDIT_LOGS_ERROR = "FETCH_AUDIT_LOGS_ERROR";
